import React, { FC } from 'react';
import { t, Trans } from '@lingui/macro';

import HowBrandWorks from '@rover/components/src/HowBrandWorks';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';
import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';
import { PetType } from '@rover/types/src/Pet';

import { PageSectionId, useSectionRef } from '../hooks/useSectionRef';

interface SeoLocationHowBrandWorksProps {
  serviceTypeName: string;
  petType?: PetType;
}

interface StepDefinition {
  heading: string;
  content: string;
}

const SeoLocationHowBrandWorks: FC<SeoLocationHowBrandWorksProps> = ({
  serviceTypeName,
  petType,
}) => {
  const brandDisplayName = getBrandDisplayName();

  const steps = getBrandSpecificValue<StepDefinition[]>({
    rover: [
      {
        heading: t`Search`,
        content: t`Browse profiles of sitters near you who offer ${serviceTypeName}`,
      },
      {
        heading: t`Meet & Greet`,
        content: t`Schedule a free in-person Meet & Greet to find the perfect fit`,
      },
      {
        heading: t`Book & Pay`,
        content: t`It's that easy! All payments are processed through ${brandDisplayName}'s secured platform`,
      },
    ],
    catInAFlat: [
      {
        heading: t`Search`,
        content: t`Read verified reviews by pet parents like yourself and choose a sitter who's a great match for you and your pets`,
      },
      {
        heading: t`Book & Pay`,
        content: t`It's that easy! All payments are processed through ${brandDisplayName}'s secured platform`,
      },
      {
        heading: t`Relax`,
        content: t`Enjoy daily photo updates and know your cat is in safe hands while you're away.`,
      },
    ],
  });
  const ref = useSectionRef(PageSectionId.HowBrandWorks);

  return (
    <HowBrandWorks htmlRef={ref}>
      <HowBrandWorks.Display variant="heading">
        <Trans>How {brandDisplayName} works</Trans>
      </HowBrandWorks.Display>
      <HowBrandWorks.List petType={petType}>
        {steps.map(({ heading, content }, index) => (
          <HowBrandWorks.ListItem key={index}>
            <HowBrandWorks.ItemHeading step={index + 1}>{heading}</HowBrandWorks.ItemHeading>
            <HowBrandWorks.ItemContent>{content}</HowBrandWorks.ItemContent>
          </HowBrandWorks.ListItem>
        ))}
      </HowBrandWorks.List>
    </HowBrandWorks>
  );
};

export default SeoLocationHowBrandWorks;
